/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum InvoiceStages {
    UPLOADED = 'UPLOADED',
    DRAFT = 'DRAFT',
    VALIDATED = 'VALIDATED',
    APPROVED = 'APPROVED',
    REJECTED = 'REJECTED',
    FINALIZED = 'FINALIZED',
    SETTLED = 'SETTLED',
}
